import React, { useState } from 'react'

import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination } from 'swiper'
import 'swiper/css/pagination'
import people1 from '../../../../images/internShips/people_1.png'
import people2 from '../../../../images/internShips/people_2.png'
import people3 from '../../../../images/internShips/people_3.png'
import people4 from '../../../../images/internShips/people_4.png'
import people5 from '../../../../images/internShips/people_5.png'
import people6 from '../../../../images/internShips/people_6.png'
import people7 from '../../../../images/internShips/people_7.png'
import people8 from '../../../../images/internShips/people_8.png'
import people9 from '../../../../images/internShips/people_9.png'
import people10 from '../../../../images/internShips/people_10.png'
import people11 from '../../../../images/internShips/people_11.png'


import styles from './styles.module.scss'
import '../../main/personalGenerium/personal.css'

const StudentInternShipsReviews = () => {
  const [swiper, setSwiper] = useState(null);
  const [indexSwiperElem, setIndexSwiperElem] = useState(0)

  return (
    <div className={styles.wrapper}>
      <div className={styles.wr1}>
        <div className={styles.left}>
          <div>
            <p className={styles.title}>Что говорят студенты о Generium?</p>
          </div>
        </div>
        <div className={styles.right}>
          <div className='flex flex-col'>
            <p className={styles.title}>Студенты о Generium</p>
          </div>
        </div>
      </div>
      <div className={styles.wr2}>
        <div className={styles.left}>
          <div className={styles.preview_people}>
            {indexSwiperElem !== 0 ? (
              <>
                <div onClick={() => swiper.slideTo(0)}>
                  <img className='preview_people-slider-photo' src={people9} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 1 ? (
              <>
                <div onClick={() => swiper.slideTo(1)}>
                  <img className='preview_people-slider-photo' src={people10} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 2 ? (
              <>
                <div onClick={() => swiper.slideTo(2)}>
                  <img className='preview_people-slider-photo' src={people11} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 3 ? (
              <>
                <div onClick={() => swiper.slideTo(3)}>
                  <img className='preview_people-slider-photo' src={people1} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 4 ? (
              <>
                <div onClick={() => swiper.slideTo(4)}>
                  <img className='preview_people-slider-photo' src={people2} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 5 ? (
              <>
                <div onClick={() => swiper.slideTo(5)}>
                  <img className='preview_people-slider-photo' src={people3} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 6 ? (
              <>
                <div onClick={() => swiper.slideTo(6)}>
                  <img className='preview_people-slider-photo' src={people4} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 7 ? (
              <>
                <div onClick={() => swiper.slideTo(7)}>
                  <img className='preview_people-slider-photo' src={people5} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 8 ? (
              <>
                <div onClick={() => swiper.slideTo(8)}>
                  <img className='preview_people-slider-photo' src={people6} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 9 ? (
              <>
                <div onClick={() => swiper.slideTo(9)}>
                  <img className='preview_people-slider-photo' src={people7} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 10 ? (
              <>
                <div onClick={() => swiper.slideTo(10)}>
                  <img className='preview_people-slider-photo' src={people8} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}

          </div>
          <div className={styles.preview_people_active}>
            {indexSwiperElem == 0 ? (
              <><img className='preview_people_active-slider-photo' src={people9} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 1 ? (
              <><img className='preview_people_active-slider-photo' src={people10} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 2 ? (
              <><img className='preview_people_active-slider-photo' src={people11} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 3 ? (
              <><img className='preview_people_active-slider-photo' src={people1} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 4 ? (
              <><img className='preview_people_active-slider-photo' src={people2} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 5 ? (
              <><img className='preview_people_active-slider-photo' src={people3} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 6 ? (
              <><img className='preview_people_active-slider-photo' src={people4} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 7 ? (
              <><img className='preview_people_active-slider-photo' src={people5} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 8 ? (
              <><img className='preview_people_active-slider-photo' src={people6} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 9 ? (
              <><img className='preview_people_active-slider-photo' src={people7} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 10 ? (
              <><img className='preview_people_active-slider-photo' src={people8} alt='people' draggable='false'/></>
            ) : ''}
          </div>
        </div>
        <div className={styles.right}>
          <p className={styles.text2}>
            {indexSwiperElem === 0
              ? 'Мне очень понравилась программа наставничества: спокойное и понятное разъяснение сложного материала, даже когда он непонятен с первого раза.'
              + '\n\n' +
              'Моим наставником в Отделе Молекулярной биологии и биохимии был суперпрофессионал своего дела, обладающий прекрасным навыком изъяснять свой план исследования, что вижу очень важным для стажеров. Искренне рад знакомству с ним и всем отделом ОМББ — максимально камерная и дружная команда, генерирует эксперименты наперед прямо в голове, у них явно есть, чему поучиться.'
              + '\n\n' +
              'Также следует отметить уважительное отношение всех ко всем, причем неважно, кто какую позицию занимает. Ну и как не сказать про само благоустройство комплекса: лес, озера, спортивный зал и вкусные обеды (причем, за счет компании).'
              : indexSwiperElem === 1
                ? 'Больше всего за время стажировки мне запомнилось масштабы, в которых происходил процесс. Осознание того, сколько усилий специалистов и современного оборудования необходимо для того, чтобы несколько тонн клеточной жидкости превратилось всего в пару литров лекарственной субстанции, заставляет восхититься происходящим.'
                + '\n\n' +
                'Компания Generium ассоциируется у меня с людьми, которые в ней работают и людьми, чьи жизни спасают разработки и продукты Generium.'
                + '\n\n' +
                'В будущем я бы хотел заниматься исследованиями и разработками в области генной терапии и иммунологии. Стать частью одной из ведущих групп или лабораторий или возможно создать свою.'
                : indexSwiperElem === 2
                  ? 'Я проходила стажировку в отделе молекулярной диагностики в группе клеточных тестов.'
                  + '\n\n' +
                  'В лаборатории мы ежедневно практиковали методы работы с клетками, белками и нуклеиновыми кислотами, а также наблюдали, как работают с вирусами. Больше всего мне запомнилась моя работа с клетками насекомых, я почувствовала себя настоящим сотрудником компании.'
                  + '\n\n' +
                  'За время стажировки я смогла глубже познакомиться с компанией, и сегодня Генериум у меня ассоциируется с молодыми специалистами, разработками в направлении орфанных заболеваний и заботой о сотрудниках.'
                  : indexSwiperElem === 3
                    ? 'Программа Generium вызвала у меня большой интерес, поскольку я могла там применить свои знания и умения. Грамотная организация – это первое, на что я обратила внимание. Каждый работник отвечал за своей проект, начальство открыто для взаимодействия, лаборатории оснащены новейшим оборудованием. Также хочу отметить теплое и уважительное отношение людей по отношению друг к другу в отделе молекулярной диагностики, где я проходила стажировку. При этом дисциплина в работе тоже присутствовала, что важно для достижения целей.'
                    + '\n\n' +
                    'За время стажировки я поняла, что мне близки ценности компании, интересны ее проекты, приятно общаться с коллективом. Моя мечта сейчас – защитить успешно кандидатскую диссертацию, а затем устроиться на работу в компанию Generium.'
                    : indexSwiperElem === 4
                      ? 'Не могу сказать, что мне понравилось больше всего, так как я осталась довольна абсолютно всем. В течение всего месяца я была вовлечена в действующие проекты и работала над ними. Если возникали какие-то вопросы, научный руководитель и остальные сотрудники отдела сразу же помогали и отвечали на все поставленные вопросы. Дополнительно для нас провели различные экскурсии, мы посещали лекции и семинары на очень интересные темы.'
                      + '\n\n' +
                      'Не могу не отметить организацию досуга в свободное от работы время и выходные дни. Мы с ребятами, которые тоже были на стажировке, ходили в бассейн, тренажерный зал, на пляж, устраивали пикники, катались на сапах. Скучать здесь некогда.'
                      : indexSwiperElem === 5
                        ? 'Я выбрал стажировку в Generium, потому что компания располагает одним из лучших биотехнологических R&D-центров в России. Но чего я не ожидал, так это настолько теплой, приятной атмосферы в очень профессиональном коллективе. Думаю, не последнюю роль в этом сыграла инфраструктура наукограда, который напоминает кампусы ведущих вузов мира и летний лагерь одновременно.'
                        + '\n\n' +
                        'Я сразу решил, чем хочу заниматься и какие навыки планирую получить. В этом мне помогла Наталья Алексеевна – руководитель отдела, в котором я проходил стажировку. Благодаря ей и Generium в целом я еще больше уверился в желании строить карьеру в области биотехнологий.'
                        : indexSwiperElem === 6
                          ? 'Я уже давно решила, что хочу работать в инновационной фармацевтической компании. Поэтому выбор, естественно, пал на Generium. После прохождения конкурса я попала в отдел аналитических методов, в котором всегда много работы и скучать не приходится. Нужно было схватывать на лету новую информацию. Было здорово поработать в потрясающей лаборатории на ВЭЖХ-системах и другом современном оборудовании. Коллеги в отделе – отдельный большой плюс стажировки. Это команда, которая всегда откликнется и поможет новичку.'
                          + '\n\n' +
                          'Думаю, стажировка в  Generium подойдет любому, кто уже знает, что хочет попасть именно в эту компанию, и мечтает внести свой вклад в производство лекарств для спасения жизней людей.'
                          : indexSwiperElem === 7
                            ? 'Программа Generium оказалась для меня крайне интересной. Сотрудники компании рассказывали много полезных фактов и делились опытом, общаясь на равных. Благодаря сплоченности коллектива сложилось очень хорошее впечатление о компании, возникло желание работать здесь после завершения стажировки.'
                            + '\n\n' +
                            'Немаловажным фактором при выборе оказалась и локация предприятия. Здесь всё расположено настолько близко, а также создана такая комфортная атмосфера, что в рабочее время почти не устаешь, а вечером есть много времени и, что важно, возможность отдохнуть.'
                            + '\n\n' +
                            'Наша стажировка и совместная работа с научными руководителями были полезными, поскольку мы получили неоценимый опыт и знания о процессах, в которых участвовали.'
                            : indexSwiperElem === 8
                              ? 'Мне посчастливилось оказаться на программе Mabstudy, частью которой является летняя стажировка в Generium. Самым важным для меня было получить новые знания и опыт, что мне удалось благодаря отзывчивому коллективу. Наиболее полезным для меня было время, проведенное за хроматографом, а также общение с коллегами, готовыми ответить на любые вопросы.'
                              + '\n\n' +
                              'Эта программа подойдет ребятам, которые заинтересованы в биотехнологии и готовы много учиться, и тем, кто хочет попробовать себя в новой области. По завершении программы я бы хотела продолжить работу в R&D-центре Generium.'
                              : indexSwiperElem === 9
                                ? 'Стажировка в Generium – это отличная возможность познакомиться поближе с компанией и коллективом в целом, более углубленно посмотреть на весь рабочий процесс и поучаствовать в нем.'
                                + '\n\n' +
                                'За все время стажировки мне больше всего понравилось отношение коллег и их готовность разъяснить все непонятные моменты. Самым эффективным считаю практическую работу на современном оборудовании и участие в реальных проектах. Благодаря этому каждый день ты сталкиваешься с производственными проблемами и нюансами, которые необходимо решать и учитывать.'
                                + '\n\n' +
                                'По моему мнению, программа подойдет людям, которые уже знают, в какой области они хотят работать и развиваться, и могут быстро воспринимать новую информацию.'
                                : indexSwiperElem === 10
                                  ? 'Фарминдустрия – это непрерывно развивающаяся область, с которой я давно хотела познакомиться. Мне всегда были интересны подходы к патогенетической терапии орфанных заболеваний. Компания Generium как раз занимается этой проблемой, поэтому я решила пройти стажировку именно здесь. Знакомство с различными отделами и структурой R&D-центра дало четкое понимание того, как устроено фармпроизводство в настоящее время. За время стажировки я освоила различные методики и поучаствовала в работе над реальными кейсами компании.'
                                  + '\n\n' +
                                  'Эта программа, безусловно, подходит для тех, кто хочет познакомиться с компанией Generium и погрузиться в ее рабочую атмосферу.'
                                  : null}
          </p>
          <div className="slider_main_mod_pg">
            <Swiper
              spaceBetween={70}
              slidesPerView={1}
              navigation
              onSlideChange={swiper => setIndexSwiperElem(swiper.activeIndex)}
              pagination={{
                type: 'fraction'
              }}
              onSwiper={setSwiper}
              modules={[Pagination, Navigation]}
              breakpoints={{
                640: {
                  slidesPerView: 1,
                  initialSlide: 0
                },
                480: {
                  spaceBetween: 16,
                  initialSlide: 0,
                  slideToClickedSlide: true
                },
                370: {
                  spaceBetween: 16,
                  initialSlide: 0,
                  slideToClickedSlide: true
                },
                320: {
                  spaceBetween: 16,
                  initialSlide: 0,
                  slideToClickedSlide: true
                }
              }}
            >
              <SwiperSlide id='0' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people9} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Мне очень понравилась программа наставничества: спокойное и понятное разъяснение сложного материала, даже когда он непонятен с первого раза. </p>
                    <p className={styles.text}>Моим наставником в Отделе Молекулярной биологии и биохимии был суперпрофессионал своего дела, обладающий прекрасным навыком изъяснять свой план исследования, что вижу очень важным для стажеров. Искренне рад знакомству с ним и всем отделом ОМББ — максимально камерная и дружная команда, генерирует эксперименты наперед прямо в голове, у них явно есть, чему поучиться.</p>
                    <p className={styles.text}>Также следует отметить уважительное отношение всех ко всем, причем неважно, кто какую позицию занимает. Ну и как не сказать про само благоустройство комплекса: лес, озера, спортивный зал и вкусные обеды (причем, за счет компании).</p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide id='1' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people10} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Больше всего за время стажировки мне запомнилось масштабы, в которых происходил процесс. Осознание того, сколько усилий специалистов и современного оборудования необходимо для того, чтобы несколько тонн клеточной жидкости превратилось всего в пару литров лекарственной субстанции, заставляет восхититься происходящим.</p>
                    <p className={styles.text}>Компания Generium ассоциируется у меня с людьми, которые в ней работают и людьми, чьи жизни спасают разработки и продукты Generium.</p>
                    <p className={styles.text}>В будущем я бы хотел заниматься исследованиями и разработками в области генной терапии и иммунологии. Стать частью одной из ведущих групп или лабораторий или возможно создать свою.</p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide id='2' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people11} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Я проходила стажировку в отделе молекулярной диагностики в группе клеточных тестов. </p>
                    <p className={styles.text}>В лаборатории мы ежедневно практиковали методы работы с клетками, белками и нуклеиновыми кислотами, а также наблюдали, как работают с вирусами. Больше всего мне запомнилась моя работа с клетками насекомых, я почувствовала себя настоящим сотрудником компании.</p>
                    <p className={styles.text}>За время стажировки я смогла глубже познакомиться с компанией, и сегодня Генериум у меня ассоциируется с молодыми специалистами, разработками в направлении орфанных заболеваний и заботой о сотрудниках.</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide id='3' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people1} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Программа Generium вызвала у меня большой интерес, поскольку я могла там применить свои знания и умения. Грамотная организация – это первое, на что я обратила внимание. Каждый работник отвечал за своей проект, начальство открыто для взаимодействия, лаборатории оснащены новейшим оборудованием. Также хочу отметить теплое и уважительное отношение людей по отношению друг к другу в отделе молекулярной диагностики, где я проходила стажировку. При этом дисциплина в работе тоже присутствовала, что важно для достижения целей.</p>
                    <p className={styles.text}>За время стажировки я поняла, что мне близки ценности компании, интересны ее проекты, приятно общаться с коллективом. Моя мечта сейчас – защитить успешно кандидатскую диссертацию, а затем устроиться на работу в компанию Generium.</p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide id='4' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people2} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Не могу сказать, что мне понравилось больше всего, так как я осталась довольна абсолютно всем. В течение всего месяца я была вовлечена в действующие проекты и работала над ними. Если возникали какие-то вопросы, научный руководитель и остальные сотрудники отдела сразу же помогали и отвечали на все поставленные вопросы. Дополнительно для нас провели различные экскурсии, мы посещали лекции и семинары на очень интересные темы.</p>
                    <p className={styles.text}>Не могу не отметить организацию досуга в свободное от работы время и выходные дни. Мы с ребятами, которые тоже были на стажировке, ходили в бассейн, тренажерный зал, на пляж, устраивали пикники, катались на сапах. Скучать здесь некогда.</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide id='5' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people3} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Я выбрал стажировку в Generium, потому что компания располагает одним из лучших биотехнологических R&D-центров в России. Но чего я не ожидал, так это настолько теплой, приятной атмосферы в очень профессиональном коллективе. Думаю, не последнюю роль в этом сыграла инфраструктура наукограда, который напоминает кампусы ведущих вузов мира и летний лагерь одновременно.</p>
                    <p className={styles.text}>Я сразу решил, чем хочу заниматься и какие навыки планирую получить. В этом мне помогла Наталья Алексеевна – руководитель отдела, в котором я проходил стажировку. Благодаря ей и Generium в целом я еще больше уверился в желании строить карьеру в области биотехнологий.</p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide id='6' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people4} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Я уже давно решила, что хочу работать в инновационной фармацевтической компании. Поэтому выбор, естественно, пал на Generium. После прохождения конкурса я попала в отдел аналитических методов, в котором всегда много работы и скучать не приходится. Нужно было схватывать на лету новую информацию. Было здорово поработать в потрясающей лаборатории на ВЭЖХ-системах и другом современном оборудовании. Коллеги в отделе – отдельный большой плюс стажировки. Это команда, которая всегда откликнется и поможет новичку.</p>
                    <p className={styles.text}>Думаю, стажировка в  Generium подойдет любому, кто уже знает, что хочет попасть именно в эту компанию, и мечтает внести свой вклад в производство лекарств для спасения жизней людей.</p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide id='7' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people5} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Программа Generium оказалась для меня крайне интересной. Сотрудники компании рассказывали много полезных фактов и делились опытом, общаясь на равных. Благодаря сплоченности коллектива сложилось очень хорошее впечатление о компании, возникло желание работать здесь после завершения стажировки.</p>
                    <p className={styles.text}>Немаловажным фактором при выборе оказалась и локация предприятия. Здесь всё расположено настолько близко, а также создана такая комфортная атмосфера, что в рабочее время почти не устаешь, а вечером есть много времени и, что важно, возможность отдохнуть.</p>
                    <p className={styles.text}>Наша стажировка и совместная работа с научными руководителями были полезными, поскольку мы получили неоценимый опыт и знания о процессах, в которых участвовали.</p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide id='8' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people6} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Мне посчастливилось оказаться на программе Mabstudy, частью которой является летняя стажировка в Generium. Самым важным для меня было получить новые знания и опыт, что мне удалось благодаря отзывчивому коллективу. Наиболее полезным для меня было время, проведенное за хроматографом, а также общение с коллегами, готовыми ответить на любые вопросы.</p>
                    <p className={styles.text}>Эта программа подойдет ребятам, которые заинтересованы в биотехнологии и готовы много учиться, и тем, кто хочет попробовать себя в новой области. По завершении программы я бы хотела продолжить работу в R&D-центре Generium.</p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide id='9' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people7} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Стажировка в Generium – это отличная возможность познакомиться поближе с компанией и коллективом в целом, более углубленно посмотреть на весь рабочий процесс и поучаствовать в нем.</p>
                    <p className={styles.text}>За все время стажировки мне больше всего понравилось отношение коллег и их готовность разъяснить все непонятные моменты. Самым эффективным считаю практическую работу на современном оборудовании и участие в реальных проектах. Благодаря этому каждый день ты сталкиваешься с производственными проблемами и нюансами, которые необходимо решать и учитывать.</p>
                    <p className={styles.text}>По моему мнению, программа подойдет людям, которые уже знают, в какой области они хотят работать и развиваться, и могут быстро воспринимать новую информацию.</p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide id='10' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people8} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Фарминдустрия – это непрерывно развивающаяся область, с которой я давно хотела познакомиться. Мне всегда были интересны подходы к патогенетической терапии орфанных заболеваний. Компания Generium как раз занимается этой проблемой, поэтому я решила пройти стажировку именно здесь. Знакомство с различными отделами и структурой R&D-центра дало четкое понимание того, как устроено фармпроизводство в настоящее время. За время стажировки я освоила различные методики и поучаствовала в работе над реальными кейсами компании.</p>
                    <p className={styles.text}>Эта программа, безусловно, подходит для тех, кто хочет познакомиться с компанией Generium и погрузиться в ее рабочую атмосферу.</p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
          <p className={styles.text_b}>
            {indexSwiperElem === 0 ? (
              <>
                <p>Дмитрий, СПбПУ Петра Великого</p>
                <p>Проходил стажировку в отделе молекулярной биологии и биохимии</p>
              </>
            ) : indexSwiperElem === 1 ? (
              <>
                <p>Матвей, ИТМО</p>
                <p>Проходил стажировку в отделе молекулярной диагностики</p>
              </>
            ) : indexSwiperElem === 2 ? (
              <>
                <p>Елизавета, ИТМО</p>
                <p>Проходила стажировку в отделе молекулярной диагностики</p>
              </>
            ) : indexSwiperElem === 3 ? (
              <>
                <p>Алиса, ИНМИ РАН</p>
                <p>Проходила стажировку в отделе молекулярной диагностики</p>
              </>
            ) : indexSwiperElem === 4 ? (
              <>
                <p>Дарья, Первый Московский государственный медицинский университет имени И. М. Сеченова</p>
                <p>Проходила стажировку в отделе разработки процессов, в лаборатории разработки процессов культивирования</p>
              </>
            ) : indexSwiperElem === 5 ? (
              <>
                <p>Мичил, РХТУ им. Д.И. Менделеева</p>
                <p>Проходил практику в отделе молекулярной диагностики</p>
              </>
            ) : indexSwiperElem === 6 ? (
              <>
                <p>Екатерина, МГУ имени М. В. Ломоносова</p>
                <p>Проходила стажировку в отделе аналитических методов</p>
              </>
            ) : indexSwiperElem === 7 ? (
              <>
                <p>Иван, РТУ МИРЭА</p>
                <p>Проходил стажировку в отделе разработки процессов</p>
              </>
            ) : indexSwiperElem === 8 ? (
              <>
                <p>Дарья, РТУ МИРЭА</p>
                <p>Проходила стажировку в отделе разработки процессов</p>
              </>
            ) : indexSwiperElem === 9 ? (
              <>
                <p>Екатерина, РТУ МИРЭА</p>
                <p>Проходила стажировку в отделе разработки процессов</p>
              </>
            ) : indexSwiperElem === 10 ? (
              <>
                <p>Антонина, РНИМУ им Н.И. Пирогова</p>
                <p>Проходила стажировку в отделе молекулярной диагностики</p>
              </>
            ) : ''}
          </p>
        </div>
      </div>
    </div>
  )
}

export default StudentInternShipsReviews
